/* tslint:disable */

declare var Object: any;
export interface StorageAttendanceMachineInterface {
  "id"?: number;
}

export class StorageAttendanceMachine implements StorageAttendanceMachineInterface {
  "id": number;
  constructor(data?: StorageAttendanceMachineInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `StorageAttendanceMachine`.
   */
  public static getModelName() {
    return "StorageAttendanceMachine";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of StorageAttendanceMachine for dynamic purposes.
  **/
  public static factory(data: StorageAttendanceMachineInterface): StorageAttendanceMachine{
    return new StorageAttendanceMachine(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'StorageAttendanceMachine',
      plural: 'StorageAttendanceMachines',
      path: 'StorageAttendanceMachines',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/StorageAttendanceMachine.ts